import { useContext, useEffect } from "react";
import Context from "./Context";

export default function PlayerYT({ videoId, setDuration, playerRef }) {
      const {id,setVideos,videos,notas,setNotas,tempo,setTempo}=useContext(Context)
  
    useEffect(() => {
    const createPlayer = () => {
      if (playerRef.current) return;

      playerRef.current = new window.YT.Player("player", {
        videoId,
        events: {
          onReady: (e) => {
            //e.target.setSize(window.innerWidth, 1000)
            e.target.playVideo();
          },
          onStateChange: (e) => {
            // quando o vídeo começa a tocar, a duração já está disponível
            if (e.data === window.YT.PlayerState.PLAYING) {
              setDuration(e.target.getDuration());
            }
          },
        },
      });
    };

    if (!window.YT || !window.YT.Player) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      window.onYouTubeIframeAPIReady = createPlayer;
    } else {
      createPlayer();
    }
  }, [setDuration, playerRef]);

  // troca de vídeo
  useEffect(() => {
    if (
      playerRef.current &&
      typeof playerRef.current.loadVideoById === "function"
    ) {
      playerRef.current.loadVideoById(videoId);
    }
  }, [videoId, playerRef]);

  return <div id="player"></div>
}
